var _rect, _path, _circle, _circle2, _rect2, _rect3, _circle3, _circle4, _circle5, _rect4, _text, _rect5, _text2, _text3, _rect6, _text4, _rect7, _text5, _rect8, _path2, _path3, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 48,
    fill: "#101114"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v760H0z",
    fill: "url(#grid)",
    opacity: 0.34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 130,
    r: 230,
    fill: "#2DD4BF",
    opacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 620,
    r: 250,
    fill: "#FB7185",
    opacity: 0.14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 118,
    width: 960,
    height: 524,
    rx: 34,
    fill: "#191B20",
    stroke: "rgba(255,255,255,.14)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 168,
    width: 856,
    height: 88,
    rx: 22,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.12)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 212,
    r: 14,
    fill: "#FB7185"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 212,
    r: 14,
    fill: "#F59E0B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 212,
    r: 14,
    fill: "#2DD4BF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 196,
    width: 442,
    height: 32,
    rx: 16,
    fill: "rgba(255,255,255,.1)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 219,
    fill: "#D8DEE8",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 700
  }, "Select text anywhere on the web")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 310,
    width: 448,
    height: 222,
    rx: 28,
    fill: "rgba(255,255,255,.08)",
    stroke: "rgba(255,255,255,.13)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 266,
    y: 364,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 32,
    fontWeight: 900
  }, "Helpi AI")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 266,
    y: 410,
    fill: "#CBD3DE",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, "Explain, summarize, translate")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 450,
    width: 132,
    height: 40,
    rx: 20,
    fill: "#2DD4BF"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 295,
    y: 477,
    fill: "#101114",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 19,
    fontWeight: 900
  }, "Explain")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 450,
    width: 144,
    height: 40,
    rx: 20,
    fill: "rgba(255,255,255,.1)",
    stroke: "rgba(255,255,255,.18)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 444,
    y: 477,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 19,
    fontWeight: 800
  }, "Ask AI")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 310,
    width: 250,
    height: 222,
    rx: 28,
    fill: "rgba(45,212,191,.12)",
    stroke: "rgba(45,212,191,.4)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M845 368c36 0 66 30 66 66s-30 66-66 66-66-30-66-66 30-66 66-66Z",
    fill: "#2DD4BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M813 435h64M845 403v64",
    stroke: "#101114",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 568,
    width: 684,
    height: 16,
    rx: 8,
    fill: "rgba(255,255,255,.12)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 568,
    width: 498,
    height: 16,
    rx: 8,
    fill: "#2DD4BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48",
    stroke: "white",
    strokeOpacity: 0.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpi);
export default __webpack_public_path__ + "static/media/helpi.0896cf84d89e555fdeb161187cc17ee8.svg";
export { ForwardRef as ReactComponent };